import { render, staticRenderFns } from "./VariableTipusSad.vue?vue&type=template&id=097af740&"
import script from "./VariableTipusSad.vue?vue&type=script&lang=js&"
export * from "./VariableTipusSad.vue?vue&type=script&lang=js&"
import style0 from "./VariableTipusSad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports